import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-document-paginator',
  standalone: true,
  imports:[CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './document-paginator.component.html'
})
export class DocumentPaginatorComponent {
  currentPageIdx = 0;

  prevPageIdx = -1;

  hasPrevPage = false;

  hasNextPage = false;

  _data: any
  @Input('data') set data(data: any) {
    this._data = data;
    if (data) {
      this.currentPageIdx = 0;
      this.updateStates(this.currentPageIdx);
    }
    //console.log('PAGES:', data);
  }

  @Input('page') set page(page: number) {
    this.setPage(page);
  }

  @Output('pagechanged') pagechanged = new EventEmitter<number>();

  loadNextPage() {
    if (this.setPage(this.currentPageIdx + 1)) {
      this.sendPageChange();
      this.updateStates(this.currentPageIdx);
    }
  }

  loadPrevPage() {
    if (this.setPage(this.currentPageIdx - 1)) {
      this.sendPageChange();
    }
  }

  setPage(page: number) {
    if (this._data?.pages && page >= 0 && page < this._data.pages.length) {
      this.currentPageIdx = page;
      this.updateStates(this.currentPageIdx);
      return true;
    }
    return false;
  }

  updateStates(pageIndex: number) {
    if (this._data?.pages) {
      this.hasPrevPage = pageIndex > 0;
      this.hasNextPage = pageIndex < this._data.pages.length - 1;
      this.prevPageIdx = pageIndex;
    }
  }

  sendPageChange() {
    this.pagechanged.emit(this.currentPageIdx);
  }
}
